(function() {
  'use strict';

  angular.module('app')
    .controller('ConfirmDialogCtrl', ['$scope', '$uibModalInstance', 'message', 'showWarning',
      function($scope, $uibModalInstance, message, showWarning) {
        $scope.message = message;
        $scope.showWarning = showWarning;

        $scope.ok = function () {
          $uibModalInstance.close('yes');
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }
    ]);
}());
